<div class="search-input" [class.search-input--lg]="size() === 'lg'">
  <mat-icon class="search-input__icon">search</mat-icon>
  <input
    class="search-input__input"
    type="search"
    [placeholder]="placeholder()"
    [value]="value()"
    (input)="onInput($event)"
  />
</div>
